import CustomText from "@components/CustomText";
import React, { useEffect, useMemo, useState, useRef } from "react";
import { Image, View, StyleSheet } from "react-native";
import { useNavigation } from "@react-navigation/native";
import IssueTags from "@components/IssueTags";
import ItemMarkingBtn from "@components/ItemMarkingBtn";
import { itemsQuantityStatusV3 } from "@services/api";
import toasts from "@utils/toast";
import color from "@constants/color";
import CpDbHOC from "@components/HOC/CpDbHOC";
import SingleQuantityTooltip from "@screens/CustomerOrderItems/SingleIssueTooltip/SingleQuantityTooltip";
import ItemsToReturnStrip from "@screens/MyDeliveries/components/ItemsToReturnStrip";
import ReturnLagaye from "@screens/MyDeliveries/components/ReturnLagayeButton";
import IssuesImagesUpload from "@screens/MyDeliveries/components/IssuesImagesUpload";
import LostDamageModal from "@screens/MyDeliveries/components/LostDamageModal";
import { getStateDiff, getFoundDiff } from "@utils/itemMarking";

function CrateCard({
  info,
  markingConfig,
  fetchData,
  isComboReturn,
  can_return = false,
  imagesMandatoryForSamasya,
  type,
  hideCrateId = false,
}) {
  const navigation = useNavigation();
  const [currentStateForSingleQty, setCurrentStateForSingleQty] = useState(
    info?.current_state || {
      wrong_item_received: 0,
      item_damaged: 0,
      not_found: 0,
      partial_not_found: 0,
      ofd_db_lost_damage: 0,
    },
  );
  const [images, setImages] = useState({
    wrong_item_received:
      info?.wrong_item_received_images?.map((i) => ({ url: i })) || [],
    item_damaged: info?.item_damaged_images?.map((i) => ({ url: i })) || [],
    partial_not_found:
      info?.partial_not_found_images?.map((i) => ({ url: i })) || [],
  });
  const [reason, setReason] = useState(
    info?.current_state?.item_damaged
      ? "item_damaged"
      : info?.current_state?.wrong_item_received
        ? "wrong_item_received"
        : info?.current_state?.partial_not_found
          ? "partial_not_found"
          : "",
  );
  const [visible, setVisible] = useState(false);
  const [showLostDamageModal, setShowLostDamageModal] = useState(false);
  const firstUpdate = useRef(true);
  const foundAllCall = useRef(false);
  const [isReverted, setIsReverted] = useState(false);

  const totalDefectiveItem =
    (info?.current_state?.item_damaged || 0) +
    (info?.current_state?.not_found || 0) +
    (info?.current_state?.wrong_item_received || 0) +
    (info?.current_state?.partial_not_found || 0) +
    (info?.current_state?.ofd_db_lost_damage || 0);
  const isFound = info?.found_marked && totalDefectiveItem === 0;
  const showImageCon = useMemo(() => {
    // if for 1 qty -> issue is marked & images are mandatory
    return (
      (imagesMandatoryForSamasya?.item_damaged
        ? currentStateForSingleQty?.item_damaged || 0
        : 0) +
        (imagesMandatoryForSamasya?.wrong_item_received
          ? currentStateForSingleQty?.wrong_item_received || 0
          : 0) +
        (imagesMandatoryForSamasya?.partial_not_found
          ? currentStateForSingleQty?.partial_not_found || 0
          : 0) >
        0 &&
      reason &&
      info?.total_quantity === 1
    );
  }, [
    currentStateForSingleQty,
    info?.total_quantity,
    reason,
    imagesMandatoryForSamasya,
  ]);
  useEffect(() => {
    firstUpdate.current = true;
    setCurrentStateForSingleQty(info?.current_state);
  }, [info?.current_state]);

  const saveMarkingData = async function () {
    try {
      if (
        showImageCon &&
        Object.values(images).reduce((acc, each) => acc + each.length, 0) === 0
      ) {
        toasts.showShortToast("कृप्या फोटो डालें!");
        setVisible(false);
        return;
      }
      const new_state = {
        item_damaged: currentStateForSingleQty.item_damaged,
        wrong_item_received: currentStateForSingleQty?.wrong_item_received,
        not_found: currentStateForSingleQty?.not_found,
        partial_not_found: currentStateForSingleQty?.partial_not_found,
        ofd_db_lost_damage: currentStateForSingleQty?.ofd_db_lost_damage,
      };

      const payload = {
        order_item_id: info?.order_item_id,
        hash: info?.hash,
        ofd_type: info?.ofd_type,
        type: info?.type,
        diff: getStateDiff(new_state, info?.current_state),
        found_marked: true,
        issue_images: {
          wrong_item_received: images?.wrong_item_received?.map(
            (i) => i?.url && i.url,
          ),
          item_damaged: images?.item_damaged?.map((i) => i?.url && i.url),
          partial_not_found: images?.partial_not_found?.map(
            (i) => i?.url && i.url,
          ),
        },
      };
      await itemsQuantityStatusV3(payload);
      fetchData();
      setVisible(false);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    if (isReverted) setIsReverted(false);
    else saveMarkingData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStateForSingleQty]);

  const onImageChange = (issue, issueImages) => {
    if (images[issue]) {
      setImages((p) => ({
        ...p,
        [issue]: issueImages,
      }));
    }
    // Object.values(images).reduce((acc, each) => acc + each.length, 0) > 0 &&
    //   saveMarkingData();
    setCurrentStateForSingleQty((p) => ({ ...p }));
  };

  const revertStateForSingleQty = () => {
    setImages({
      wrong_item_received:
        info?.wrong_item_received_images?.map((i) => ({ url: i })) || [],
      item_damaged: info?.item_damaged_images?.map((i) => ({ url: i })) || [],
      partial_not_found:
        info?.partial_not_found_images?.map((i) => ({ url: i })) || [],
    });
    setIsReverted(true);
    setReason(
      info?.current_state?.item_damaged
        ? "item_damaged"
        : info?.current_state?.wrong_item_received
          ? "wrong_item_received"
          : info?.current_state?.partial_not_found
            ? "partial_not_found"
            : "",
    );
    setCurrentStateForSingleQty(
      info?.current_state || {
        wrong_item_received: 0,
        item_damaged: 0,
        not_found: 0,
        partial_not_found: 0,
        found: 0,
        ofd_db_lost_damage: 0,
      },
    );
  };
  // for single quantity items
  const onCurrentStateChange = ({
    wrong_item_received = 0,
    item_damaged = 0,
    not_found = 0,
    partial_not_found = 0,
    ofd_db_lost_damage = 0,
  }) => {
    if (wrong_item_received) {
      setReason("wrong_item_received");
    }
    if (item_damaged) {
      setReason("item_damaged");
    }
    if (partial_not_found) {
      setReason("partial_not_found");
    }

    setImages({
      wrong_item_received: [],
      item_damaged: [],
      partial_not_found: [],
    });
    setVisible(false);

    setCurrentStateForSingleQty((p) => ({
      ...p,
      wrong_item_received,
      item_damaged,
      not_found,
      partial_not_found,
      ofd_db_lost_damage,
    }));
  };

  const foundAll = async () => {
    if (foundAllCall.current) {
      return;
    }

    foundAllCall.current = true;
    const payload = {
      order_item_id: info?.order_item_id,
      hash: info?.hash,
      ofd_type: info?.ofd_type,
      type: info?.type,
      diff: getFoundDiff(info?.current_state),
      found_marked: true,
    };
    await itemsQuantityStatusV3(payload);
    await fetchData();
    setVisible(false);
    foundAllCall.current = false;
  };

  return (
    <View style={styles.cardContainer}>
      <View style={{ flexDirection: "row" }}>
        <View style={styles.imageContainer}>
          <View style={styles.quantityCirle}>
            <CustomText variant="caption_2" style={styles.quantityText}>
              {info?.total_quantity}
            </CustomText>
          </View>
          <View style={styles.imageWrapper}>
            <Image
              style={styles.image}
              source={{
                uri: info?.product_image,
              }}
            />
          </View>
          {info?.crate_id ? (
            hideCrateId ? null : (
              <View style={styles.crateNumber}>
                <CustomText
                  variant="body_text_4"
                  style={styles.crateText}
                >{`${type === "PACKED_ORDERS" ? "" : "क्रेट : "}${info?.crate_id}`}</CustomText>
              </View>
            )
          ) : (
            <View style={styles.packetInfo}>
              <CustomText variant="body_text_3" style={styles.packetText}>
                पैकेट :
              </CustomText>
              <CustomText variant="caption_2" style={styles.packetText}>
                {info?.shipment_id}
              </CustomText>
            </View>
          )}
        </View>
        <View style={styles.infoContainer}>
          <CustomText variant="body_text_4" style={styles.infoText}>
            {info?.name}
          </CustomText>
          <CustomText
            variant="caption_2"
            style={{ color: "rgba(0, 0, 0, 0.56)", marginTop: 8 }}
          >
            {`क्वांटिटी : `}
            <CustomText variant="caption_1" style={{ color: "#000" }}>
              {info?.total_quantity}
            </CustomText>
          </CustomText>
          {!isComboReturn &&
            !can_return &&
            (info?.can_mark_v2 === "PRE_OFD" ||
              info?.can_mark_v2 === "POST_OFD") && (
              <View style={styles.markContainer}>
                <View style={styles.centerAlign}>
                  {info?.total_quantity === 1 ? (
                    <SingleQuantityTooltip
                      info={info}
                      markingConfig={markingConfig}
                      currentState={currentStateForSingleQty}
                      onSubmit={onCurrentStateChange}
                      visible={visible}
                      setVisible={setVisible}
                    />
                  ) : (
                    <ItemMarkingBtn
                      onPress={() =>
                        navigation.navigate("MultiQuantityIssues", {
                          info,
                          imagesMandatoryForSamasya,
                          markingConfig,
                        })
                      }
                      type="issue"
                      count={totalDefectiveItem}
                    />
                  )}
                </View>
                <View style={styles.centerAlign}>
                  <ItemMarkingBtn
                    onPress={() => foundAll()}
                    isActive={isFound}
                  />
                </View>
              </View>
            )}
          <View style={styles.issueTagsContainer}>
            <IssueTags current_state={info?.current_state} />
          </View>
          {can_return ? (
            <View style={styles.returnContainer}>
              <ReturnLagaye info={info} />
            </View>
          ) : null}
        </View>
      </View>
      {info?.ofd_state?.lost_damage > 0 && info?.can_mark_v2 === "POST_OFD" ? (
        <View
          style={{
            marginTop: 10,
            width: "100%",
            alignItems: "center",
            top: 5,
          }}
        >
          <CustomText variant="caption_4" style={{ color: color.plain_red }}>
            {info?.lost_damage_text}
          </CustomText>
        </View>
      ) : null}
      {!can_return && info?.return_quantity ? (
        <View style={{ marginTop: 20 }}>
          <ItemsToReturnStrip return_quantity={info?.return_quantity} />
        </View>
      ) : null}

      <View style={{ paddingLeft: 6, paddingRight: 6 }}>
        {showImageCon ? (
          <IssuesImagesUpload
            key={`${reason}_ImagesUpload`}
            reason={reason}
            imageRequired={showImageCon}
            // add from API currentImgs
            currentImgs={images[reason] || []}
            setUploadedImage={onImageChange}
            isSingleQty={true}
            info={info}
            revertStateForSingleQty={revertStateForSingleQty}
          />
        ) : null}
      </View>
      <LostDamageModal
        showModal={showLostDamageModal}
        setShowModal={setShowLostDamageModal}
        modalText={info?.lost_damage_text}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  cardContainer: {
    marginTop: 1,
    paddingVertical: 20,
    paddingHorizontal: 16,
    backgroundColor: "transparent",
  },
  imageContainer: {
    width: 112,
  },
  imageWrapper: {
    height: 112,
    borderRadius: 12,
    borderWidth: 0.5,
    borderColor: "rgba(0, 0, 0, 0.10)",
    padding: 9,
  },
  image: {
    height: 94,
    width: 94,
  },
  crateNumber: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    borderRadius: 10,
    paddingHorizontal: 16,
    alignSelf: "center",
    marginTop: 8,
  },
  crateText: {
    color: "rgba(0, 0, 0, 0.86)",
    marginTop: 2,
  },
  infoContainer: {
    marginTop: 4,
    marginLeft: 25,
    flex: 1,
  },
  infoText: {
    color: "rgba(0, 0, 0, 0.86)",
  },
  markContainer: {
    flexDirection: "row",
    marginTop: 20,
  },
  centerAlign: {
    flexDirection: "row",
    width: "50%",
  },
  issueTagsContainer: {
    alignItems: "flex-start",
  },
  packetInfo: {
    backgroundColor: "white",
    borderRadius: 12,
    paddingHorizontal: 8,
    flexDirection: "column",
    alignItems: "center",
    marginTop: 10,
  },
  packetText: {
    color: "black",
    marginTop: 2,
  },
  returnContainer: {
    alignItems: "flex-start",
  },
  quantityCirle: {
    position: "absolute",
    width: 30,
    height: 30,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 15,
    backgroundColor: "black",
    top: -12,
    right: -12,
    zIndex: 1,
  },
  quantityText: {
    color: "white",
  },
});

export default CpDbHOC(CrateCard);
